import type { Entry } from 'contentful';
import type * as GlobalComponents from '#components';
import type { GetComponentProps } from '~/types/GetComponentProps';
import type { CONTENT_TYPE } from '~~/lib/ContentfulService';

type Components = typeof GlobalComponents;

type ContentfulComponentPropsShape = {
  item: Entry<unknown>;
};
// Filtered components, only allow components with matching Name and Props type shape
type ContentfulComponentMap = {
  [
    K in keyof Components as K extends `Contentful${string}`
      ? GetComponentProps<Components[K]> extends ContentfulComponentPropsShape
        ? K
        : never
      : never
  ]: K;
};
type ContentfulComponentKeys = keyof ContentfulComponentMap;

const componentMap: Partial<Record<CONTENT_TYPE, ContentfulComponentKeys>> = {
  contentPage: 'ContentfulContentPage',
  headline: 'ContentfulHeadline',
  textMedia: 'ContentfulTextMedia',
  badge: 'ContentfulBadge',
  spacer: 'ContentfulSpacer',
  tile: 'ContentfulTile',
  tiles: 'ContentfulTiles',
  customHtml: 'ContentfulCustomHTML',
  link: 'ContentfulLink',
  textImageTeaser: 'ContentfulTextImageTeaser',
  textImageTeaserList: 'ContentfulTextImageTeaserList',
  carouselSection: 'ContentfulCardCarouselSection',
  image: 'ContentfulImage',
  textTeaserCardList: 'ContentfulTextTeaserCardList',
  contentCardList: 'ContentfulCardsBlock',
  video: 'ContentfulVideo',
  table: 'ContentfulTable',
  featuresTable: 'ContentfulTableDiv',
  productComparison: 'ContentfulProductComparison',
  icon: 'ContentfulIconEditorial',
  linksGroup: 'ContentfulLinksGroup',
  testimonialList: 'ContentfulTestimonialList',
  heroArticleSection: 'ContentfulHeroArticleSection',
  heroProductSection: 'ContentfulHeroProductSection',
  heroOverviewSection: 'ContentfulHeroOverviewSection',
  tagCloudContainer: 'ContentfulTagCloudContainer',
  tabSection: 'ContentfulTabsSection',
  ctaSection: 'ContentfulCtaSection',
  contentTabs: 'ContentfulContentTabs',
  columns: 'ContentfulColumns',
  accordionSection: 'ContentfulAccordionSection',
  tagOverviewSection: 'ContentfulTagOverviewSection',
  mediaTabs: 'ContentfulMediaTabs',
  animation: 'ContentfulAnimation',
  productList: 'ContentfulProductsListSection',
  technicalComponent: 'ContentfulTechnicalComponent',
  experience: 'ContentfulExperience',
  multiExperience: 'ContentfulMultiExperience',
  paywall: 'ContentfulPaywall',
  sectionBox: 'ContentfulSectionBox',
  logoGrid: 'ContentfulLogoGridBlock',
  codeBlock: 'ContentfulCodeBlock'
};

export default componentMap;
